import { render } from "./allRequest.vue?vue&type=template&id=0f8720ea"
import script from "./allRequest.vue?vue&type=script&lang=js"
export * from "./allRequest.vue?vue&type=script&lang=js"

import "./allRequest.vue?vue&type=style&index=0&id=0f8720ea&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__